export default "__VITE_ASSET__DTltZjQG__"